export default __webpack_public_path__ + "static/media/shop_products.8ce23fd9.csv";